import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import { useRoutes } from './hooks/useRoutes';
import './index.css';
import LaunchLandingPage from './pages/LaunchLandingPage';
import ThankYouPage from './pages/ThankYouPage';
import BioPage from './pages/BioPage';
import DocsPage from './pages/DocsPage';
import LessonsPage from './pages/LessonsPage';
import SurveyPage from './pages/SurveyPage';
import DashboardPage from './pages/DashboardPage';

// Security wrapper component
function SecurityWrapper({ children }: { children: React.ReactNode }) {
  return <>{children}</>;
}

// Wrapper component to handle dynamic routes
function RouteHandler() {
  const { routes, loading, error } = useRoutes();

  if (loading) {
    return <div>Carregando...</div>;
  }

  if (error) {
    console.error('Erro ao carregar rotas:', error);
    return <div>Erro ao carregar rotas</div>;
  }

  return (
    <Routes>
      {/* Rota do Dashboard - Adicionada estaticamente */}
      <Route path="/dashboard" element={<DashboardPage />} />
      
      {/* Rotas dinâmicas do Supabase */}
      {routes.map((route) => (
        <Route
          key={route.id}
          path={route.path}
          element={route.element}
        />
      ))}
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <SecurityWrapper>
          <RouteHandler />
        </SecurityWrapper>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;